/**
 * File: src/components/header.js
 * Mô tả: Component hiển thị thanh Header cố định, logo thương hiệu, menu điều hướng và nút chuyển đổi ngôn ngữ Anh / Việt.
 * Liên quan: src/i18n/i18n-service.js, src/data/site-config.js, src/styles/layout.css
 */

import { siteConfig } from '../data/site-config.js';
import { createElement } from '../utils/dom.js';
import { getLanguage, setLanguage, t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderHeader = () => {
  const header = createElement('header', { className: 'site-header' });

  const renderContent = () => {
    const currentLang = getLanguage();

    header.innerHTML = `
      <div class="container header-inner" style="display: flex; align-items: center; justify-content: space-between;">
        <a href="/" class="brand-logo" aria-label="${siteConfig.name} Home">
          <img src="/assets/images/brand/logo.webp" alt="SNT Games Logo" class="logo-icon" style="object-fit: contain; width: 40px; height: 40px; border-radius: 8px;" />
          <span>${siteConfig.name}</span>
        </a>

        <button class="mobile-menu-toggle btn btn-secondary" aria-expanded="false" aria-controls="main-navigation">Menu</button>
        <nav id="main-navigation" aria-label="Main Navigation">
          <ul class="nav-menu" style="align-items: center; gap: 1.25rem;">
            <li><a href="/" class="nav-link">${t('nav.home')}</a></li>
            <li><a href="/#games" class="nav-link">${t('nav.games')}</a></li>
            <li><a href="/#about" class="nav-link">${t('nav.studio')}</a></li>
            <li><a href="/#newsletter" class="nav-link">${t('footer.contact')}</a></li>
            
            <li>
              <div style="display: flex; gap: 4px; background: var(--bg-tertiary); padding: 4px; border-radius: 20px; border: var(--border-glass);">
                <button id="lang-btn-en" style="padding: 4px 10px; border-radius: 16px; border: none; font-size: 0.8rem; font-weight: 700; cursor: pointer; transition: all 0.2s; background: ${currentLang === 'en' ? 'var(--color-primary)' : 'transparent'}; color: ${currentLang === 'en' ? '#fff' : 'var(--color-text-dim)'};">
                  🇺🇸 EN
                </button>
                <button id="lang-btn-vi" style="padding: 4px 10px; border-radius: 16px; border: none; font-size: 0.8rem; font-weight: 700; cursor: pointer; transition: all 0.2s; background: ${currentLang === 'vi' ? 'var(--color-primary)' : 'transparent'}; color: ${currentLang === 'vi' ? '#fff' : 'var(--color-text-dim)'};">
                  🇻🇳 VI
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    `;

    const toggle = header.querySelector('.mobile-menu-toggle');
    const closeMenu = () => {
      header.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    header.querySelector('nav').addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
    header.onkeydown = (event) => {
      if (event.key === 'Escape') { closeMenu(); toggle.focus(); }
    };
    const enBtn = header.querySelector('#lang-btn-en');
    const viBtn = header.querySelector('#lang-btn-vi');

    if (enBtn) enBtn.addEventListener('click', () => setLanguage('en'));
    if (viBtn) viBtn.addEventListener('click', () => setLanguage('vi'));
  };

  renderContent();
  onLanguageChange(() => renderContent());

  return header;
};
